export default __webpack_public_path__ + "static/23-ab1248f0e6aa96b0ae658c80c4dba4a2.png";